var evtWhitelist = [
  'TransformBoxHandle,tlh',
  'TransformBoxHandle,trh',
  'TransformBoxHandle,blh',
  'TransformBoxHandle,brh',
  'TransformBoxHandle,tmh',
  'TransformBoxHandle,rmh',
  'TransformBoxHandle,bmh',
  'TransformBoxHandle,lmh',
  'ImageTransformBoxHandle,tlh',
  'ImageTransformBoxHandle,trh',
  'ImageTransformBoxHandle,blh',
  'ImageTransformBoxHandle,brh',
  'ImageTransformBoxHandle,tmh',
  'ImageTransformBoxHandle,rmh',
  'ImageTransformBoxHandle,bmh',
  'ImageTransformBoxHandle,lmh',
  'SectionBoundary,bottomMargin',
  'SectionBoundary,height',
  'RootBoundary,pageLeft',
  'RootBoundary,pageRight',
  'RootBoundary,topPadding',
  'SectionTransformBox,moveSection',
  'SectionTransformBoxHandle,bmh',
];

export default evtWhitelist;


// WEBPACK FOOTER //
// ./src/events/trigger-save-events-whitelist.js